import React, { useEffect }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import ProjectCostPriorityList from 'components/Agile/projectCostPriority/projectCostPriorityList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import ProjectCostPriorityAdd from 'components/Agile/projectCostPriority/projectCostPriorityMaintenance/projectCostPriorityAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchProjectCostPrioritys,
    getAllProjectCostPriority,
    getUnselectedAllProjectCostPriority,
    handleProjectCostPriorityRequestClose,
    showProjectCostPriorityLoader,
    onAddProjectCostPriority,
    onFilterSelectedProjectCostPriority,
    onFilterProjectCostPriorityOptionSelect,
    onToggleProjectCostPriorityDrawer,
    updateSearchProjectCostPriority,
    filterProjectCostPriority,
} from 'actions/projectCostPriority';

const filterOptions = [
    {
        id: 1,
        name: 'All projectCostPrioritys',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred projectCostPrioritys',
        icon: 'zmdi-star'
    }
];

const Component = () => {
    const dispatch = useDispatch();
    const width = useSelector(state => state.settings.width);

    const loader = useSelector(state => state.projectCostPrioritys.loader);
    const alertMessage = useSelector(state => state.projectCostPrioritys.alertMessage);
    const showMessage = useSelector(state => state.projectCostPrioritys.showMessage);
    const noContentFoundMessage = useSelector(state => state.projectCostPrioritys.noContentFoundMessage);
    const drawerState = useSelector(state => state.projectCostPrioritys.drawerState);
    const projectCostPriority = useSelector(state => state.projectCostPrioritys.projectCostPriority);
    const searchProjectCostPriority = useSelector(state => state.projectCostPrioritys.searchProjectCostPriority);
    const projectCostPriorityList = useSelector(state => state.projectCostPrioritys.projectCostPriorityList);
    const selectedProjectCostPrioritys = useSelector(state => state.projectCostPrioritys.selectedProjectCostPrioritys);
    const addProjectCostPriorityState = useSelector(state => state.projectCostPrioritys.addProjectCostPriorityState);
    const selectedSectionId = useSelector(state => state.projectCostPrioritys.selectedSectionId);

    useEffect(() => {
        dispatch(showProjectCostPriorityLoader());
        dispatch(fetchProjectCostPrioritys());
    }, []);

    const onAllProjectCostPrioritySelect = () => {
        const selectAll = selectedProjectCostPrioritys < projectCostPriorityList.length;
        if (selectAll) {
            dispatch(getAllProjectCostPriority());
        } else {
            dispatch(getUnselectedAllProjectCostPriority());
        }
    };

    const updatingSearchProjectCostPriority = (evt) => {
        dispatch(updateSearchProjectCostPriority(evt.target.value));
        dispatch(filterProjectCostPriority(evt.target.value));
    };

    const projectCostPriorityRequestClose = () => {
        dispatch(handleProjectCostPriorityRequestClose());
    };

    const projectCostPrioritySideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.projectCostPrioritys" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddProjectCostPriority())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="projectCostPriority.addProjectCostPriority" /></span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === selectedSectionId ? 'active' : ''} 
                                    onClick={() => dispatch(onFilterProjectCostPriorityOptionSelect(option))}>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onToggleProjectCostPriorityDrawer())}
                        sidebar={projectCostPrioritySideBar(projectCostPriority)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {projectCostPrioritySideBar(projectCostPriority)}
                </div>
                <div className="module-box">
                    <div className="module-box-header">
                        <span className="icon-btn drawer-btn d-flex d-xl-none"
                            onClick={() => dispatch(onToggleProjectCostPriorityDrawer())}>
                            <i className="zmdi zmdi-menu" />
                        </span>
                        <AppModuleHeader
                            placeholder="Search projectCostPriority"
                            notification={false}
                            apps={false}
                            user={projectCostPriority}
                            onChange={(event) => updatingSearchProjectCostPriority(event)}
                            value={searchProjectCostPriority} />
                    </div>
                    <div className="module-box-content">
                        <div className="module-box-topbar">
                            <div className="form-control-checkbox d-flex">
                                <div className="form-checkbox">
                                    <input type="checkbox"
                                        checked={selectedProjectCostPrioritys > 0}
                                        onChange={onAllProjectCostPrioritySelect} />
                                    <span className="check">
                                        <i className="zmdi zmdi-check zmdi-hc-lg" />
                                    </span>
                                </div>
                            </div>
                            <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                onClick={() => dispatch(onFilterSelectedProjectCostPriority())} >
                                <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                <span><IntlMessages id="label.filter.selected" /></span>
                            </Button>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                projectCostPriorityList && projectCostPriorityList.length > 0 ?
                                    <ProjectCostPriorityList />
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>
                    </div>
                </div>
            </div>
            <ProjectCostPriorityAdd
                open={addProjectCostPriorityState}
            />
            {showMessage && NotificationManager.success(alertMessage, projectCostPriorityRequestClose())}
            <NotificationContainer />
        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/projectCostPriority/component.js